import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AccountWorkflowsFetchFailedAction = {
	type: 'ACCOUNT_WORKFLOWS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AccountWorkflowsFetchFailedAction => ({
	type: 'ACCOUNT_WORKFLOWS_FETCH_FAILED',
	payload,
});
